import script from "./EditorJsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorJsEditor.vue?vue&type=script&setup=true&lang=js"

import "./EditorJsEditor.vue?vue&type=style&index=0&id=ab620cfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab620cfc"]])

export default __exports__